module.exports = __webpack_public_path__ + "img/spvie.747915b8.png";